export class PromotionSummary {
  readonly stockistId: number;
  readonly issueId: number;
  readonly totalPurchased: number;
  readonly freebieEligibleQuantity: number;
  readonly freebiesEarned: number;
  readonly freebiesGranted: number;
  readonly freebiesPending: number;


  constructor(data: {
    stockistId: number;
    issueId: number;
    totalPurchased: number;
    freebieEligibleQuantity: number;
    freebiesEarned: number;
    freebiesGranted: number;
    freebiesPending: number;
  }) {
    this.stockistId = data.stockistId;
    this.issueId = data.issueId;
    this.totalPurchased = data.totalPurchased;
    this.freebieEligibleQuantity = data.freebieEligibleQuantity;
    this.freebiesEarned = data.freebiesEarned;
    this.freebiesGranted = data.freebiesGranted;
    this.freebiesPending = data.freebiesPending;
  }
}